import classNames from "classnames";
import React, { type HTMLAttributes } from "react";

interface Props extends Omit<HTMLAttributes<HTMLSpanElement>, "className"> {
    children: React.ReactNode;
    isError?: boolean;
}

export const Caption: React.FC<Props> = ({ children, isError, ...rest }) => {
    return (
        <span
            className={classNames("mx_Caption", {
                mx_Caption_error: isError,
            })}
            {...rest}
        >
            {children}
        </span>
    );
};
